module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup"
  }, [_c('div', {
    staticClass: "popup__overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "popup__content",
    class: {
      video: this.popup === 'Video'
    }
  }, [_c('a', {
    staticClass: "popup__close",
    class: {
      info: this.popup === 'Info'
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closePopup($event)
      }
    }
  }, [_c('close')], 1), _vm._v(" "), _c(_vm.popup, {
    tag: "component"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fd4d609","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/popups/BasePopup.vue
// module id = 493
// module chunks = 1